import styled from 'styled-components'

const WindowContent = styled.div`
  padding: 10px 10px 10px 10px;
  overflow: auto;
  height: 100%;

  table {
    min-width: 1250px;
  }
`
export default WindowContent
